import { render, staticRenderFns } from "./SendSmsNetgsm.vue?vue&type=template&id=54f20276&scoped=true"
import script from "./SendSmsNetgsm.vue?vue&type=script&lang=js"
export * from "./SendSmsNetgsm.vue?vue&type=script&lang=js"
import style0 from "./SendSmsNetgsm.vue?vue&type=style&index=0&id=54f20276&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f20276",
  null
  
)

export default component.exports